module.exports = __webpack_public_path__ + "img/img_quick_review.4ceac980.jpg";